import CostForm from './form-cost';

export default CostForm;